export function isRestaurantOpen(timings) {
  const now = new Date();

  return timings.some(slot => {
    const [openH, openM] = slot.open.split(":");
    const [closeH, closeM] = slot.close.split(":");

    const openTime = new Date();
    openTime.setHours(openH, openM, 0, 0);

    const closeTime = new Date();
    closeTime.setHours(closeH, closeM, 0, 0);

    return now >= openTime && now <= closeTime;
  });
}

export function getNextOpeningDate(timings) {
  const now = new Date();

  for (let slot of timings) {
    const [h, m] = slot.open.split(":").map(Number);
    const openTime = new Date();
    openTime.setHours(h, m, 0, 0);

    if (openTime > now) {
      return openTime;
    }
  }

  // If no slots left today → tomorrow first slot
  const [h, m] = timings[0].open.split(":").map(Number);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(h, m, 0, 0);

  return tomorrow;
}

export const getScannerType = () => {
    const ua = navigator.userAgent || "";

    // iOS QR / Camera / in-app webview
    if (
      /iPhone|iPad|iPod/i.test(ua) &&
      /WebView|wv|Safari/i.test(ua) &&
      !/CriOS|FxiOS|OPiOS/i.test(ua)
    ) {
      return "ios_scanner";
    }

    // Android QR / Google Lens / OEM scanners
    if (
      /Android/i.test(ua) &&
      (/wv|WebView|Scanner|Scan|QR|Lens/i.test(ua))
    ) {
      return "android_scanner";
    }

    return "desktop";
  };


export function formatCountdown(ms) {
  if (ms <= 0) return "00:00";

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours > 0
    ? `${hours}h ${minutes}m ${seconds}s`
    : `${minutes}m ${seconds}s`;
}

export function format12Hour(time) {
  const [h, m] = time.split(":").map(Number);
  const hour12 = h % 12 || 12;
  const ampm = h >= 12 ? "PM" : "AM";
  return `${hour12}${m ? `:${m}` : ""} ${ampm}`;
}
